import { RefObject } from 'react';

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export function focusFirstElement(
  container: HTMLElement | null,
  initialFocusRef?: RefObject<HTMLElement>
): void {
  const target = initialFocusRef?.current
    || container?.querySelector<HTMLElement>(FOCUSABLE_SELECTOR)
    || container;

  window.setTimeout(() => target?.focus(), 0);
}

export function returnFocus(returnFocusRef?: RefObject<HTMLElement>): void {
  window.setTimeout(() => returnFocusRef?.current?.focus(), 0);
}

export function keepFocusInside(container: HTMLElement | null, event: KeyboardEvent): void {
  if (!container || event.key !== 'Tab') return;

  const focusable = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR))
    .filter((element) => !element.hasAttribute('disabled') && element.tabIndex !== -1);

  if (focusable.length === 0) {
    event.preventDefault();
    container.focus();
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const active = document.activeElement;

  if (event.shiftKey && active === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first.focus();
  }
}
